export const environment = {
    production: true,
    API_URL: 'https://back.corecredit.corefluens.co/api/',
    enterprise: "corecredit",
    api_username: 'corecredit',
    api_password: 'D4Fre8rI53Rq',
    enable_seas: false
};
